import React, { useState, useEffect } from "react";

import Center from "../utils/Center";
import Loading from "../utils/Loading";
import { USHER } from "../../constants";
import JobSnapshotsGraph from "../posts/JobSnapshotsGraph";
import { firebaseDateObjToJSDate } from "../../apis/firebase";

export default function DestinationReport({
  destination,
}: {
  destination: Destination;
}) {
  const [error, setError] = useState<string>();
  const [data, setData] = useState<JobStats | null>(null);

  useEffect(() => {
    async function getData() {
      try {
        const res = await fetch(USHER, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            destination_stats: true,
            destinationId: destination.id,
          }),
        });
        if (res.ok) {
          let data: JobStats = await res.json();
          data.snapshots = (data.snapshots || []).map((snapshot) => {
            return {
              ...snapshot,
              d: {
                toDate: () => firebaseDateObjToJSDate(snapshot.d),
              },
            };
          });
          setData(data);
        } else {
          setError("Can not get the stats for this campaign.");
        }
      } catch (err) {
        console.log(err);
        setError("Can not get the stats for this destination.");
      }
    }
    setData(null);
    getData();
  }, [destination.id]);

  if (data !== null) {
    return (
      <>
        <h2 className="tac mb1">
          {data.engagements} user engagement{data.engagements !== 1 ? "s" : ""}{" "}
          in total
        </h2>
        <JobSnapshotsGraph stats={data} />
      </>
    );
  }

  if (error) {
    return (
      <Center width={200}>
        <p className="tac error mt1">{error}</p>
      </Center>
    );
  }

  return (
    <>
      <Center width={40}>
        <Loading />
      </Center>
      <Center width={200}>
        <p className="tac mt1">Getting statistical data. Please wait.</p>
      </Center>
    </>
  );
}
